import { Tooltip } from "@components/tooltip-container";
import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatting } from "@north-beam/nb-common";
import { useClientSettings } from "@pages/mmm/hooks/use-client-settings";

import { type TableRowType } from "../performance-tracking-table";

export const TotalBudgetDataFormatter = ({
  column,
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const row = _row as TableRowType;
  const { user } = useUser();
  const { formattedCycleDateRange } = useClientSettings();

  const target = row.data.budgetedSpend;

  return (
    <div className="font-medium text-sm flex-center h-full overflow-hidden">
      <Tooltip
        noInfoCircle
        content={
          <div className="font-semibold">
            <div className="text-xs tracking-wide mb-1">
              TOTAL PERIOD BUDGET
            </div>
            <div className="text-gray+2 font-normal">
              {formattedCycleDateRange}
            </div>
            <div className="text-lg text-cosmic">
              {formatting.formatCurrency(target, {
                precision: "exact",
                code: user.currencies.currentCurrency,
              })}
            </div>
          </div>
        }
      >
        <i className="fa-regular fa-bullseye-arrow mr-1 text-cosmic" />
      </Tooltip>
      {formatting.formatCurrency(target, {
        precision: "approximate",
        code: user.currencies.currentCurrency,
      })}
    </div>
  );
};
